import { AccessoriesItemData } from '@rta/rta-blueprint-library';
import { Select, useChakraSelectProps } from 'chakra-react-select';

import { Box, Button, Tooltip } from '@chakra-ui/react';
import { selectAccessoryDropdown, setSelectedAccessory, useAppDispatch, useAppSelector } from '@state';
import { useAddAccessoryFeature, useShowAccessoryDropdownFeature } from '@features';
import { useEffect, useState } from 'react';

export const EstimateItemAddAccessories = () => {
	const dispatch = useAppDispatch();

	const accessory = useShowAccessoryDropdownFeature();
	const accessoryDropdown = useAppSelector(selectAccessoryDropdown);
	const addAccessory = useAddAccessoryFeature();

	const [selectedSkus, setSelectedSkus] = useState<string[]>([]);


	useEffect(() => {
		dispatch(setSelectedAccessory(selectedSkus));
	}, [selectedSkus]);


	const multiSelectOptions: any = [];

	AccessoriesItemData.getAllSkus().map((sku) => (
		multiSelectOptions.push({
			fontSize: 'sm',
			label: sku
		})
	));

	const selectProps = useChakraSelectProps({
		isMulti: false,
		colorScheme: 'blue',
		value: selectedSkus.map((sku) => ({ label: sku })),
		options: multiSelectOptions,
		onChange: (newValue, actionMeta) => {
			if (actionMeta.action === 'clear') {
				setSelectedSkus([]);
			} else if (actionMeta.action === 'select-option' || actionMeta.action === 'remove-value') {
				console.log('newValue', newValue);
				if (newValue) setSelectedSkus([newValue.label]);
			}
		},
		placeholder: 'Select Accessory'
	});


	return (
		<Box textAlign="center" marginTop="5px" borderTop={'1px'} pt={'10px'}>
			{accessoryDropdown && (
				<Box display="flex" flexDirection="column" gap="5px" marginBottom="10px">
					<Select {...selectProps}/>

					<Tooltip label={addAccessory.tooltip} aria-label={addAccessory.tooltip}>
						<Button size="xs" isDisabled={addAccessory.disabled} onClick={() => {
							addAccessory.handler(); setSelectedSkus([]);
						}}>
							{addAccessory.label}
						</Button>
					</Tooltip>
				</Box>
			)}
			<Tooltip label={accessory.tooltip} aria-label={accessory.tooltip}>
				<Button onClick={accessory.handler} disabled={accessory.disabled}>{accessory.label}</Button>
			</Tooltip>
		</Box>
	);
};
